import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getAccountNotes} from 'src/openapi/admin/apis/GetAccountNotesApi';
import {saveAccountNotes} from 'src/openapi/admin/apis/SaveAccountNotesApi';
import {useAppDispatch} from 'src/store/hooks';

import type {AccountNotes} from 'src/openapi/admin/models/AccountNotes';

type Props = {
    accountId: number,
};

export const useAccountNotes = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getAccountNotes({accountId}),
    ), [accountId, apiDispatch]);

    const saveDispatchAction = useCallback((accountNotes: AccountNotes) => apiDispatch(
        saveAccountNotes({accountId, accountNotes}),
    ), [accountId, apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        initValue: {value: ''},
    });
};
